import { Image, Text } from '@ui/atoms';
import { cn } from '@ui/atoms/utils/utils';
import React from 'react';

const FilterChip = ({
    label = 'Filter',
    canClear = true,
    icon,
    isSelected = false,
    onClick = () => {},
    count = null,
    className,
    isFilterOrSortChip = false,
}) => {
    return (
        <div
            className={cn(
                'flex items-center gap-1 p-2 bg-basicWhite border rounded-lg border-gray-200 max-w-fit md:w-full cursor-pointer relative min-w-max',
                className,
                {
                    'bg-secondary-50 border-secondary-300': isSelected,
                    'bg-primary-50 border-primary-100':
                        isSelected && isFilterOrSortChip,
                }
            )}
            onClick={onClick}
        >
            {icon ? <Image src={icon} alt={label} /> : null}
            <Text
                content={label}
                className={cn('text-gray-500 p5-medium whitespace-nowrap', {
                    'text-primary-500': isSelected,
                })}
            />
            {isSelected && canClear ? (
                <Image src="/images/close-blue.svg" alt="filter" />
            ) : null}
            {count ? (
                <div className="w-4 h-4 rounded-full bg-basicWhite text-primary-500 p7-medium flex-center">
                    {count}
                </div>
            ) : null}
        </div>
    );
};

export default FilterChip;
